import type { cloneDeep } from 'lodash-es'
import { cloneDeepWith, isPlainObject } from 'lodash-es'

export const attemptParseJSON = (str?: string | null) => {
  if (!str) return
  try {
    return JSON.parse(str)
  } catch (e) {}
}

export const flattenObject = (
  o: any,
  r: any = {},
  path: string[] = [],
  separator = '.',
) => {
  for (const [k, v] of Object.entries(o)) {
    if (isPlainObject(v)) {
      flattenObject(v, r, [...path, k], separator)
      continue
    }
    r[[...path, k].join(separator)] = v
  }
  return r
}

export const clonePlainObjectDeep: typeof cloneDeep = o =>
  cloneDeepWith(o, v => (isPlainObject(v) ? undefined : v))

export const isServiceWorkerAvailable =
  typeof navigator !== 'undefined' && 'serviceWorker' in navigator
export const isNotificationAvailable =
  typeof window !== 'undefined' && 'Notification' in window
